// @ts-nocheck
/**
 * Système de Liste de Souhaits Shopify
 * Gestion complète des favoris avec stockage localStorage
 */

class WishlistManager {
  constructor() {
    this.storageKey = 'shopify_wishlist';
    this.cookieKey = 'wishlist_data';
    this.cookieExpireDays = 365; // 1 an de persistance
    this.wishlist = this.loadWishlist();
    this.init();
  }

  init() {
    console.log('🎯 Initialisation du système de wishlist');
    
    // Si des handles ont été corrigés, sauvegarder immédiatement
    if (this.wishlist.some(item => item.handle)) {
      const needsSave = this.wishlist.some((item, index) => {
        const stored = localStorage.getItem(this.storageKey);
        if (!stored) return true;
        const storedList = JSON.parse(stored);
        return !storedList[index]?.handle && item.handle;
      });
      
      if (needsSave) {
        console.log('💾 Sauvegarde des handles corrigés');
        this.saveWishlist();
      }
    }
    
    this.bindEvents();
    this.updateUI();
    this.initializePage();
  }

  bindEvents() {
    // Événements pour ajouter/retirer des produits
    
    // Support pour les boutons configurables
    document.addEventListener('click', (e) => {
      const configurableBtn = e.target.closest('.product-wishlist-configurable-btn');
      if (configurableBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        const productId = configurableBtn.dataset.productId;
        if (productId) {
          if (this.isInWishlist(productId)) {
            this.removeFromWishlist(productId, configurableBtn);
          } else {
            this.addToWishlist(productId, configurableBtn);
          }
        }
      }
    });
    document.addEventListener('click', (e) => {
      const addBtn = e.target.closest('[data-add-to-wishlist]');
      const removeBtn = e.target.closest('[data-remove-from-wishlist]');
      const toggleBtn = e.target.closest('[data-toggle-wishlist]');

      if (addBtn) {
        e.preventDefault();
        const productId = addBtn.dataset.productId || addBtn.dataset.addToWishlist;
        this.addToWishlist(productId, addBtn);
      }

      if (removeBtn) {
        e.preventDefault();
        const productId = removeBtn.dataset.productId || removeBtn.dataset.removeFromWishlist;
                
        // Si pas de productId direct, chercher dans le parent
        if (!productId) {
          const wishlistItem = removeBtn.closest('[data-wishlist-item]');
          if (wishlistItem && wishlistItem.dataset.productId) {
            this.removeFromWishlist(wishlistItem.dataset.productId);
            return;
          }
        }
        
        this.removeFromWishlist(productId);
      }

      if (toggleBtn) {
        e.preventDefault();
        const productId = toggleBtn.dataset.productId || toggleBtn.dataset.toggleWishlist;
        this.toggleWishlist(productId, toggleBtn);
      }
    });

    // Événements pour la page wishlist
    document.addEventListener('click', (e) => {
      const clearBtn = e.target.closest('[data-clear-wishlist]');
      const addAllBtn = e.target.closest('[data-add-all-to-cart]');
      const addToCartBtn = e.target.closest('[data-add-to-cart]');

      if (clearBtn) {
        e.preventDefault();
        this.clearWishlist();
      }

      if (addAllBtn) {
        e.preventDefault();
        this.addAllToCart();
      }

      if (addToCartBtn) {
        e.preventDefault();
        const productId = addToCartBtn.closest('[data-wishlist-item]').dataset.productId;
        this.addToCart(productId);
      }
    });

    // Mettre à jour les compteurs
    document.addEventListener('DOMContentLoaded', () => {
      this.updateCounters();
    });
  }

  // Gestion du stockage hybride (localStorage + cookies)
  loadWishlist() {
    try {
      // Essayer d'abord localStorage
      let stored = localStorage.getItem(this.storageKey);
      
      if (!stored) {
        // Fallback sur cookies si localStorage vide
        stored = this.getCookie(this.cookieKey);
        if (stored) {
          console.log('📦 Restauration depuis cookie');
          // Restaurer dans localStorage
          localStorage.setItem(this.storageKey, stored);
        }
      }
      
      const wishlist = stored ? JSON.parse(stored) : [];
      
      // CORRECTION: Ajouter les handles manquants aux anciens items
      const fixedWishlist = wishlist.map(item => {
        if (!item.handle && item.url) {
          // Extraire le handle depuis l'URL si disponible
          const match = item.url.match(/\/products\/([a-z0-9\-]+)/i);
          if (match) {
            console.log(`🔧 Correction handle manquant pour ${item.title}: ${match[1]}`);
            return { ...item, handle: match[1] };
          }
        }
        return item;
      });
      
      console.log('✅ Wishlist chargée:', fixedWishlist.length, 'produits');
      return fixedWishlist;
    } catch (error) {
      console.error('Erreur lors du chargement de la wishlist:', error);
      // Essayer de récupérer depuis cookie en cas d'erreur
      try {
        const cookieData = this.getCookie(this.cookieKey);
        if (cookieData) {
          return JSON.parse(cookieData);
        }
      } catch (e) {
        console.error('Erreur cookie:', e);
      }
      return [];
    }
  }

  saveWishlist() {
    try {
      const data = JSON.stringify(this.wishlist);
      
      // Sauvegarder dans localStorage
      localStorage.setItem(this.storageKey, data);
      
      // Sauvegarder aussi dans cookie pour persistance
      this.setCookie(this.cookieKey, data, this.cookieExpireDays);
      
      console.log('💾 Wishlist sauvegardée (localStorage + cookie):', this.wishlist.length, 'produits');
    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error);
      // Essayer au moins de sauvegarder dans cookie
      try {
        this.setCookie(this.cookieKey, JSON.stringify(this.wishlist), this.cookieExpireDays);
      } catch (e) {
        console.error('Erreur sauvegarde cookie:', e);
      }
    }
  }

  // Actions principales
  addToWishlist(productId, button = null) {
    if (!productId) return;

    productId = String(productId);

    // Déterminer le handle pour l'appel API (data-product-handle ou lien dans la carte)
    const productHandle = this.deriveProductHandle(button) || productId;

    if (this.isInWishlist(productId)) {
      this.showNotification('Ce produit est déjà dans votre liste de souhaits', 'info');
      return;
    }

    // Récupérer les informations du produit via handle
    this.fetchProductInfo(productHandle)
      .then(productData => {
        this.wishlist.push({
          id: productId,
          handle: productData.handle, // Stocker le handle pour re-fetch ultérieur
          ...productData,
          addedAt: Date.now()
        });

        this.saveWishlist();
        this.updateUI();
        this.showNotification('Produit ajouté à votre liste de souhaits ❤️', 'success');

        // Mettre à jour le bouton si fourni
        if (button) {
          this.updateButtonState(button, true);
        }
      })
      .catch(error => {
        console.error('Erreur lors de l\'ajout:', error);
        this.showNotification('Erreur lors de l\'ajout du produit', 'error');
      });
  }

  removeFromWishlist(productId) {
    if (!productId) return;

    productId = String(productId);
    const initialLength = this.wishlist.length;
    
    this.wishlist = this.wishlist.filter(item => item.id !== productId);

    if (this.wishlist.length < initialLength) {
      this.saveWishlist();
      this.updateUI();
      this.showNotification('Produit retiré de votre liste de souhaits', 'info');

      // Mettre à jour tous les boutons pour ce produit
      this.updateProductButtons(productId, false);

      // Si on est sur la page wishlist, mettre à jour l'affichage
      if (this.isWishlistPage()) {
        this.renderWishlistPage();
      }
    }
  }

  toggleWishlist(productId, button = null) {
    if (!productId) return;

    if (this.isInWishlist(productId)) {
      this.removeFromWishlist(productId);
    } else {
      this.addToWishlist(productId, button);
    }
  }

  clearWishlist() {
    if (this.wishlist.length === 0) {
      this.showNotification('Votre liste de souhaits est déjà vide', 'info');
      return;
    }

    const confirmed = confirm(`Êtes-vous sûr de vouloir vider votre liste de souhaits ? (${this.wishlist.length} produit(s))`);
    
    if (confirmed) {
      this.wishlist = [];
      this.saveWishlist();
      this.deleteCookie(this.cookieKey); // Supprimer aussi le cookie
      this.updateUI();
      this.showNotification('Liste de souhaits vidée', 'info');

      if (this.isWishlistPage()) {
        this.renderWishlistPage();
      }
    }
  }

  // Utilitaires
  isInWishlist(productId) {
    return this.wishlist.some(item => item.id === String(productId));
  }

  getWishlistCount() {
    return this.wishlist.length;
  }

  isWishlistPage() {
    return document.querySelector('[data-wishlist-page]') !== null;
  }

  // Mise à jour de l'interface
  updateUI() {
    this.updateCounters();
    this.updateAllButtons();
  }

  updateCounters() {
    const count = this.getWishlistCount();
    const counters = document.querySelectorAll('[data-wishlist-count]');
    
    counters.forEach(counter => {
      counter.textContent = count;
      counter.style.display = count > 0 ? 'inline' : 'none';
    });
  }

  updateAllButtons() {
    // Mettre à jour tous les boutons toggle/add
    document.querySelectorAll('[data-toggle-wishlist], [data-add-to-wishlist]').forEach(button => {
      const productId = button.dataset.productId || button.dataset.toggleWishlist || button.dataset.addToWishlist;
      if (productId) {
        this.updateButtonState(button, this.isInWishlist(productId));
      }
    });
  }

  updateProductButtons(productId, isInWishlist) {
    const buttons = document.querySelectorAll(`[data-product-id="${productId}"], [data-toggle-wishlist="${productId}"], [data-add-to-wishlist="${productId}"]`);
    buttons.forEach(button => {
      this.updateButtonState(button, isInWishlist);
    });
  }

  updateButtonState(button, isInWishlist) {
    if (!button) return;

    // Classes CSS
    button.classList.toggle('wishlist-added', isInWishlist);
    button.classList.toggle('wishlist-not-added', !isInWishlist);

    // Texte du bouton
    const addText = button.dataset.textAdd || 'Ajouter aux favoris';
    const removeText = button.dataset.textRemove || 'Retirer des favoris';
    
    const textElement = button.querySelector('[data-wishlist-text]') || button;
    if (textElement.tagName === 'BUTTON' || textElement.tagName === 'A') {
      const icon = button.querySelector('svg');
      const iconHtml = icon ? icon.outerHTML : '';
      textElement.innerHTML = isInWishlist ? `${iconHtml} ${removeText}`.trim() : `${iconHtml} ${addText}`.trim();
    } else {
      textElement.textContent = isInWishlist ? removeText : addText;
    }

    // Attributs pour l'accessibilité
    button.setAttribute('aria-label', isInWishlist ? removeText : addText);
    button.setAttribute('title', isInWishlist ? removeText : addText);
  }

  // Récupération des données produit
  async fetchProductInfo(identifier) {
    // identifier peut être un handle (string avec tirets) ou un ID (nombre)
    console.log(`📡 Fetch produit via: ${identifier}`);
    
    try {
      const response = await fetch(`/products/${identifier}.js`);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status} - Produit "${identifier}" introuvable`);
      }
      
      const product = await response.json();
      console.log(`✅ Produit récupéré:`, product.title);
      
      return {
        title: product.title,
        handle: product.handle,
        vendor: product.vendor,
        price: product.price,
        compare_at_price: product.compare_at_price,
        available: product.available,
        featured_image: product.featured_image,
        url: `/products/${product.handle}`,
        variants: product.variants
      };
    } catch (error) {
      console.error(`❌ Erreur lors de la récupération du produit "${identifier}":`, error.message);
      throw error;
    }
  }

  // Déduction du handle à partir du bouton / DOM
  deriveProductHandle(button) {
    if (!button) return null;
    
    // Priorité 1: data-product-handle explicite
    if (button.dataset && button.dataset.productHandle) {
      console.log('✅ Handle trouvé via data-product-handle:', button.dataset.productHandle);
      return button.dataset.productHandle;
    }
    
    // Priorité 2: Chercher dans la carte produit
    const card = button.closest('product-card, .product-card, [data-product-id]');
    if (card) {
      const anchor = card.querySelector('a[href*="/products/"]');
      if (anchor && anchor.getAttribute('href')) {
        const href = anchor.getAttribute('href');
        const match = href.match(/\/products\/([a-z0-9\-]+)/i);
        if (match) {
          console.log('✅ Handle trouvé via URL:', match[1]);
          return match[1];
        }
      }
    }
    
    // Priorité 3: Utiliser product ID directement comme fallback
    const productId = button.dataset.productId || button.dataset.toggleWishlist || button.dataset.addToWishlist;
    if (productId) {
      console.log('⚠️ Utilisation de product ID comme handle:', productId);
      return productId;
    }
    
    console.warn('❌ Aucun handle trouvé pour le bouton:', button);
    return null;
  }

  // Gestion de la page wishlist
  async initializePage() {
    if (!this.isWishlistPage()) {
      console.log('ℹ️ Pas sur la page wishlist, initialisation ignorée');
      return;
    }

    console.log('📄 Initialisation de la page wishlist - Wishlist items:', this.wishlist.length);
    console.log('📦 Contenu wishlist:', this.wishlist);
    await this.renderWishlistPage();
  }

  async renderWishlistPage() {
    console.log('🎨 Début renderWishlistPage - Items:', this.wishlist.length);
    
    const loadingElement = document.querySelector('[data-wishlist-loading]');
    const emptyElement = document.querySelector('[data-wishlist-empty]');
    const gridElement = document.querySelector('[data-wishlist-grid]');
    const actionsElement = document.querySelector('[data-wishlist-actions]');
    const itemsContainer = document.querySelector('[data-wishlist-items]');

    console.log('🔍 Éléments DOM trouvés:', {
      loading: !!loadingElement,
      empty: !!emptyElement,
      grid: !!gridElement,
      actions: !!actionsElement,
      items: !!itemsContainer
    });

    if (!itemsContainer) {
      console.error('❌ Container [data-wishlist-items] introuvable!');
      return;
    }

    // Afficher le loading
    if (loadingElement) loadingElement.style.display = 'block';
    if (emptyElement) emptyElement.style.display = 'none';
    if (gridElement) gridElement.style.display = 'none';
    if (actionsElement) actionsElement.style.display = 'none';

    try {
      if (this.wishlist.length === 0) {
        // Liste vide
        if (loadingElement) loadingElement.style.display = 'none';
        if (emptyElement) emptyElement.style.display = 'block';
        return;
      }

      // Récupérer les données à jour des produits
      const productsData = await Promise.all(
        this.wishlist.map(async (item) => {
          try {
            // IMPORTANT: Utiliser le handle stocké (priorité) ou l'ID en fallback
            const identifier = item.handle || item.id;
            console.log(`🔄 Re-fetch produit: ${identifier} (handle: ${!!item.handle})`);
            const freshData = await this.fetchProductInfo(identifier);
            return { ...item, ...freshData };
          } catch (error) {
            console.warn(`❌ Produit ${item.handle || item.id} non trouvé, suppression de la wishlist`);
            return null;
          }
        })
      );

      // Filtrer les produits non trouvés
      const validProducts = productsData.filter(Boolean);
      
      // Mettre à jour la wishlist si des produits ont été supprimés
      if (validProducts.length !== this.wishlist.length) {
        this.wishlist = validProducts;
        this.saveWishlist();
      }

      // Rendre les produits
      itemsContainer.innerHTML = '';
      validProducts.forEach(product => {
        const productElement = this.createProductElement(product);
        itemsContainer.appendChild(productElement);
      });

      // Afficher la grille
      if (loadingElement) loadingElement.style.display = 'none';
      if (gridElement) gridElement.style.display = 'block';
      if (actionsElement) actionsElement.style.display = 'flex';

    } catch (error) {
      console.error('Erreur lors du rendu de la page wishlist:', error);
      if (loadingElement) loadingElement.style.display = 'none';
      if (emptyElement) emptyElement.style.display = 'block';
    }
  }

  createProductElement(product) {
    const template = document.getElementById('wishlist-item-template');
    if (!template) {
      console.error('Template wishlist-item-template non trouvé');
      return document.createElement('div');
    }

    const clone = template.content.cloneNode(true);
    const item = clone.querySelector('.wishlist-item');

    // Données de base
    item.dataset.productId = product.id;

    // Image
    const imageLink = item.querySelector('.wishlist-item__image-link');
    const image = item.querySelector('.wishlist-item__img');
    if (product.featured_image && imageLink && image) {
      imageLink.href = product.url;
      image.src = product.featured_image;
      image.alt = product.title;
    }

    // Titre
    const titleLink = item.querySelector('.wishlist-item__title-link');
    if (titleLink) {
      titleLink.href = product.url;
      titleLink.textContent = product.title;
    }

    // Prix
    const currentPrice = item.querySelector('.wishlist-item__price-current');
    const originalPrice = item.querySelector('.wishlist-item__price-original');
    
    if (currentPrice) {
      currentPrice.textContent = this.formatPrice(product.price);
    }
    
    if (originalPrice && product.compare_at_price && product.compare_at_price > product.price) {
      originalPrice.textContent = this.formatPrice(product.compare_at_price);
      originalPrice.style.display = 'inline';
    }

    // Vendor
    const vendor = item.querySelector('.wishlist-item__vendor');
    const vendorText = item.querySelector('.wishlist-item__vendor-text');
    if (product.vendor && vendor && vendorText) {
      vendorText.textContent = product.vendor;
      vendor.style.display = 'block';
    }

    // Bouton "Voir le produit"
    const viewButton = item.querySelector('.wishlist-item__view-product');
    if (viewButton) {
      viewButton.href = product.url;
    }

    // Bouton "Ajouter au panier"
    const addToCartBtn = item.querySelector('.wishlist-item__add-to-cart');
    if (addToCartBtn) {
      if (!product.available) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Rupture de stock';
      }
    }

    return item;
  }

  // Gestion du panier
  async addToCart(productId) {
    try {
      const product = this.wishlist.find(item => item.id === productId);
      if (!product || !product.variants || product.variants.length === 0) {
        throw new Error('Produit ou variants non trouvés');
      }

      // Prendre le premier variant disponible
      const availableVariant = product.variants.find(v => v.available) || product.variants[0];

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: availableVariant.id,
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      
      // Déclencher l'événement de mise à jour du panier
      document.dispatchEvent(new CustomEvent('cart:updated', { 
        detail: { items: [data] } 
      }));

      // Rafraîchir le panier si disponible
      if (window.theme?.cart?.refresh) {
        window.theme.cart.refresh();
      }

    } catch (error) {
      console.error('Erreur lors de l\'ajout au panier:', error);
      this.showNotification('Erreur lors de l\'ajout au panier', 'error');
    }
  }

  async addAllToCart() {
    if (this.wishlist.length === 0) return;

    const availableProducts = this.wishlist.filter(product => 
      product.available && product.variants && product.variants.length > 0
    );

    if (availableProducts.length === 0) {
      this.showNotification('Aucun produit disponible à ajouter au panier', 'info');
      return;
    }

    let successCount = 0;
    let errorCount = 0;

    for (const product of availableProducts) {
      try {
        await this.addToCart(product.id);
        successCount++;
      } catch (error) {
        errorCount++;
      }
    }

    if (successCount > 0) {
      this.showNotification(`${successCount} produit(s) ajouté(s) au panier !`, 'success');
    }

    if (errorCount > 0) {
      this.showNotification(`${errorCount} produit(s) n'ont pas pu être ajoutés`, 'error');
    }
  }

  // Gestion des cookies
  setCookie(name, value, days) {
    try {
      const expires = new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
      // Encoder en base64 pour éviter les problèmes avec caractères spéciaux
      const encodedValue = btoa(encodeURIComponent(value));
      document.cookie = `${name}=${encodedValue};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
    } catch (error) {
      console.error('Erreur setCookie:', error);
    }
  }

  getCookie(name) {
    try {
      const nameEQ = name + '=';
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(nameEQ) === 0) {
          const encodedValue = cookie.substring(nameEQ.length);
          // Décoder depuis base64
          return decodeURIComponent(atob(encodedValue));
        }
      }
    } catch (error) {
      console.error('Erreur getCookie:', error);
    }
    return null;
  }

  deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  }

  // Utilitaires
  formatPrice(price) {
    return new Intl.NumberFormat('fr-CA', {
      style: 'currency',
      currency: 'CAD'
    }).format(price / 100);
  }

  showNotification(message, type = 'info') {
    // Nouveau système toast si disponible
    if (window.toast && typeof window.toast.show === 'function') {
      window.toast.show(message, { type });
      return;
    }
    // Fallback minimal si toast non chargé
    console.log(`[${type}] ${message}`);
  }

  // API publique
  getWishlist() {
    return [...this.wishlist];
  }

  exportWishlist() {
    return JSON.stringify(this.wishlist, null, 2);
  }

  importWishlist(jsonData) {
    try {
      const imported = JSON.parse(jsonData);
      if (Array.isArray(imported)) {
        this.wishlist = imported;
        this.saveWishlist();
        this.updateUI();
        return true;
      }
    } catch (error) {
      console.error('Erreur lors de l\'import:', error);
    }
    return false;
  }
}

// Initialisation automatique
/** @type {WishlistManager | undefined} */
let wishlistManager;

function initWishlist() {
  if (wishlistManager) {
    console.log('⚠️ Wishlist déjà initialisée, réinitialisation de la page...');
    wishlistManager.initializePage();
    return;
  }
  
  console.log('🚀 Initialisation du système wishlist...');
  wishlistManager = new WishlistManager();
  console.log('✅ Système de wishlist initialisé');
}

// Initialiser immédiatement si DOM déjà chargé, sinon attendre
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlist);
} else {
  // DOM déjà chargé, initialiser immédiatement
  initWishlist();
}

// Export pour utilisation externe
window.WishlistManager = WishlistManager;
window.wishlist = {
  add: (productId) => wishlistManager?.addToWishlist(productId),
  remove: (productId) => wishlistManager?.removeFromWishlist(productId),
  toggle: (productId) => wishlistManager?.toggleWishlist(productId),
  clear: () => wishlistManager?.clearWishlist(),
  count: () => wishlistManager?.getWishlistCount() || 0,
  contains: (productId) => wishlistManager?.isInWishlist(productId) || false,
  getAll: () => wishlistManager?.getWishlist() || []
};